import { render, staticRenderFns } from "./classBatch.vue?vue&type=template&id=453586fb&scoped=true"
import script from "./classBatch.vue?vue&type=script&lang=js"
export * from "./classBatch.vue?vue&type=script&lang=js"
import style0 from "./classBatch.vue?vue&type=style&index=0&id=453586fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453586fb",
  null
  
)

export default component.exports